import { StepType } from "@reactour/tour";

interface ITourItem {
  steps: StepType[];
}

export interface ITourData {
  [key: string]: ITourItem;
}

export const tourData: ITourData = {
  login: {
    steps: [
      {
        selector: "#tour-login-mode",
        content:
          "با کاهش درخشندگی صفحه و استفاده از رنگ‌های تیره، خستگی چشمان شما در مشاهده پلتفرم کاهش می‌یابد و می‌توانید بر روی محتوا متمرکز شوید. با کلیک برروی این دکمه می توانید حالت Dark Mode را روشن کنید.",
      },
      {
        selector: "#tour-login-search",
        content:
          "کاربر گرامـی می توانیـد نام مرکـز خود را در این باکس جستجـو کنیـد تا راحت تـر مرکـز مورد نظـر خود را انتخـاب نماییـد .",
      },
      {
        selector: "#tour-login-hospital-list",
        content:
          " کاربـر گرامـی مرکـزی که در آن مشغـول به کارهستیـد و می خواهیـد به آن ورود کنیـد را از این لیست انتخـاب نمـایید.",
      },
    ],
  },
  publicCrm: {
    steps: [
      {
        selector: "#tour-report-type",
        content:
          "در این قسمت نوع تکمیل فرم خود را انتخاب کنید ، اگر از مرکز شکایت دارد شکایت ثبت نمایید یا اگر قصد تقدیر و تشکر دارید تقدیر و تشکر را انتخاب کنید.",
      },
      {
        selector: "#tour-phone-tracking",
        content:
          "در صورتی که تمایل دارید کد پیگیری برای شما ارسال گردد شماره موبایل خود را وارد کنید.",
      },
    ],
  },
  committeeDashboard: {
    steps: [
      {
        selector: "#realtime_gif",
        content:
          "شما بدون نیاز به رفرش کردن (بروزرسانی صفحه) می توانید وقایع و اطلاعات به روز را مشاهده کنید، صفحات گزارش خطاهای آماری سنجاب Realtime هستند.",
      },
      {
        selector: "#date_parents",
        content:
          "برای دریافت گزارش بهتر و مطلوب تر از فیلتر های زمانی نمودار ها استفاده کنید.",
      },
      {
        selector: "#committee_filter",
        content:
          "با انتخاب نام کمیته، می‌توانید دلایل لغو جلسات آن کمیته را مشاهده کنید.",
      },
    ],
  },
  hospitalLogin: {
    steps:
      process.env.REACT_APP_LOGIN_TOUR === "TRUE"
        ? [
            {
              selector: "#login-submit",
              content:
                "با فشردن دکمه ورود، یک کد تأیید از طریق پیامک به شماره تلفن همراه شما ارسال خواهد شد. لطفاً این کد را در پنجره‌ای که برای شما باز می‌شود وارد کنید. در صورتی که پنجره تأیید را ببندید یا کد وارد شده اشتباه باشد، لازم است ۵ دقیقه صبر کنید و مجدداً اقدام کنید. از همکاری شما سپاسگزاریم.",
            },
            {
              selector: "#tour-no-auth-services",
              content:
                "کاربر گرامی شما می توانید با حفظ محرمانگی فرم هایی که در بخش خدمات بدون احراز هویت هستند را تکمیل کنید. سامانه ی سنجاب به حریم خصوصی شما احترام گذاشته و اطلاعات هویتی شما را ذخیره نخواهد کرد.",
            },
          ]
        : [
            {
              selector: "#tour-no-auth-services",
              content:
                "کاربر گرامی شما می توانید با حفظ محرمانگی فرم هایی که در بخش خدمات بدون احراز هویت هستند را تکمیل کنید. سامانه ی سنجاب به حریم خصوصی شما احترام گذاشته و اطلاعات هویتی شما را ذخیره نخواهد کرد.",
            },
          ],
  },
  surveyTour: {
    steps: [
      {
        selector: "#next-btn",
        content:
          "در صورتی که برای این سوال نظری ندارید، می‌توانید با استفاده از این دکمه به سوال بعدی بروید.",
      },
      {
        selector: "#back-btn",
        content:
          "با استفاده از این دکمه می‌توانید به سوال قبلی بازگردید و پاسخ خود را مرور یا ویرایش کنید.",
      },
    ],
  },
  publicTour: {
    steps: [
      {
        selector: "#first-question",
        content:
          "کاربر گرامی، در صورتی که برای سوالات نظری ندارید، لطفا به آن سوال پاسخ ندهید.",
      },
    ],
  },
  errorsDashboard: {
    steps: [
      {
        selector: "#realtime_gif",
        content:
          "شما بدون نیاز به رفرش کردن (بروزرسانی صفحه) می توانید وقایع و اطلاعات به روز را مشاهده کنید، صفحات گزارش خطاهای آماری سنجاب Realtime هستند.",
      },
      {
        selector: "#date_parents",
        content:
          "برای دریافت گزارش بهتر و مطلوب تر از فیلتر های زمانی نمودار ها استفاده کنید.",
      },
    ],
  },
  ticketTour: {
    steps: [
      {
        selector: "#new-ticket",
        content:
          "شما می توانید با استفاده از این دکمه  درخواست خود را با همکاران ما در میان بکذارید .",
      },
    ],
  },
};
